import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import cy from './locales/cy.json';

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    cy
  },
  globalInjection: true
});

export default i18n;